import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { getLegalEntity, State } from '@cemex/cmx-client-layout';
import { createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getUserCountry } from '@ordersnproducts/store';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { map } from 'rxjs/operators';

@Injectable()
export class CanEntryCalendarViewGuard implements CanActivate {
  constructor(
    private store: Store<State>,
    private featureToggle: FeatureToggleService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store
      .select(
        createSelector(getLegalEntity, getUserCountry, (legalEntity, countryCode) => ({ legalEntity, countryCode })),
      )
      .pipe(
        map(({ countryCode }) => {
          const actived = this.featureToggle.isFeatureEnabled(Features.CalendarView, {
            countryCode: countryCode,
          });
          return actived;
        }),
      );
  }
}
